import { ActionTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyKeuringPlatformTypesStore from "./property-keuring-platform-types.store";


const keuringPlatformActions: ActionTree<IPropertyEditState, {}> = <ActionTree<IPropertyEditState, {}>>{
  [propertyKeuringPlatformTypesStore.Get.PUBLISH_CERTINERGIE]: ({ getters, commit }, param: number) => { 
    return getters.service['getPublishCertinergie'](param)
      .then((data) => { 
        commit(propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_RESET);
        commit(propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_ASSIGN_VALUE, { PropertyId: param });
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  },
  [propertyKeuringPlatformTypesStore.Get.PUBLISH_CERTIPLUS]: ({ getters, commit }, param: number) => {
    return getters.service['getPublishCertiplus'](param)
      .then((data) => {
        commit(propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_RESET);
        commit(propertyKeuringPlatformTypesStore.Set.KEURING_PLATFORM_ASSIGN_VALUE, { PropertyId: param });
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  },
  publishCertinergie: ({ getters, commit }) => {
    return getters.service['publishCertinergie'](getters.certinergie)
      .then((data) => {
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  },
  publishCertiplus: ({ getters, commit }) => {
    return getters.service['publishCertiplus'](getters.certiplus)
      .then((data) => {
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
  },
  publishKeuringsPlatform: ({ getters, commit }, request) => {   
    return getters.service['publishKeuringsPlatform'](request)
      .then((data) => {
        return Promise.resolve(data);
      }).catch(error => Promise.reject(error))
    },
  getKeuringsPlatformOrders: ({ getters, commit }, request) => {
      return getters.service['getKeuringsPlatformOrders'](request)
          .then((data) => {
              return Promise.resolve(data);
          }).catch(error => Promise.reject(error))
    },
    generateEnergyPerformanceUrl: ({ getters, commit }, request) => {   
      return getters.service['generateEnergyPerformanceUrl'](request)
        .then((data) => {
          return Promise.resolve(data);
        }).catch(error => Promise.reject(error))
      },
}

export default keuringPlatformActions;